import React from 'react'
import CRUD from '../../components/common/CRUD/CRUD'
import { fields } from '../../models/humanResources/employeeModel'
import { createCRUDService } from '../../services/crudService'
import { Breadcrumb } from 'react-bootstrap'

const EmployeesView = () => {
  const { listItems, deleteItem, createItem, updateItem } = createCRUDService(
    '/api/human_resources/employees'
  )
  return (
    <main style={{ padding: '1rem 0' }}>
      <CRUD
        fields={fields}
        paginated
        entityName='Empleado'
        entityNamePlural='Empleados'
        showAllInList
        dataSource={listItems}
        onDelete={deleteItem}
        onCreate={createItem}
        onUpdate={updateItem}
      />
    </main>
  )
}

EmployeesView.breadcrumbs = () => (
  <Breadcrumb.Item key='breadcrumb-employees' href='/employees' active>
    Empleados
  </Breadcrumb.Item>
)

export default EmployeesView
